import { __esmMin as e } from "../../_virtual/_rolldown/runtime.es.js";
// libs/ui-lib/src/assets/icons/chevronRightPrimary.svg?raw
var t, n = e((() => {
	t = "<svg width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 11.6071L1.41176 13L8 6.5L1.41176 0L0 1.39286L5.17647 6.5L0 11.6071Z\" fill=\"#4D39E9\"/>\n</svg>\n";
}));
n();
export { t as default, n as init_chevronRightPrimary };
